import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import moment from 'moment';
import { editNoteForm } from 'services/annotations/duck';
import EditNoteForm from 'components/organisms/forms/EditNote';

class EditNoteContainer extends Component {
    render() {
        return (
            <EditNoteForm
                dispatch={this.props.dispatch}
                handleToggle={this.props.handleToggle}
                formHeader='Edit Note'
                initialValues={this.props.initialValues}
                handleSubmit={this.props.handleSubmit.bind(null, editNoteForm)} >
                {this.props.children}
            </EditNoteForm>
        );
    }
}

const form = 'editNote';

const mapStateToProps = (state, props) => ({
    initialValues: {
        adminContext: props.adminContext,
        handleToggle: props.handleToggle,
        annotationId: props.note.id,
        entityId: props.entityId,
        meta: {
            ...props.note.meta,
            start: moment(props.note.meta.start).format('MM-DD-YYYY'),
            end: moment(props.note.meta.end).format('MM-DD-YYYY'),
        }
    },

});

export default compose(
    connect(mapStateToProps),
    reduxForm({
        form,
        enableReinitialize: true
    })
)(EditNoteContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/EditNoteContainer.js